import React from "react";
import { Row, Col, Card } from "antd";
import logos from "./logos";
import Slider from "react-slick";

function Logo({ logo }) {
  return (
    <Card
      style={{ width: "100%", border: "none", borderRadius: 0 }}
      bodyStyle={{ padding: 0 }}
    >
      <div
        className="custom-image"
        style={{
          width: "120px",
          border: "10px solid #fff",
          height: "175px",
          background: `url(${logo}) no-repeat center center`,
          backgroundSize: "contain"
        }}
      />
    </Card>
  );
}

function Carousel() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 2000,
    className: "carousel",
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } }
    ]
  }
  
  return (
    <Row style={{ backgroundColor: "#fff", padding: "50px 0" }}>
      <Col sm={24} md={{ span: 12, offset: 6 }}>
        <div style={{ padding: "20px 0px 20px" }}>
          <hr
            style={{
              border: "none",
              borderTop: "1px solid #1ABC9C"
            }}
          />
          <div
            style={{
              color: "#1ABC9C",
              backgroundColor: "#fff",
              display: "inline-block",
              padding: "0 20px",
              top: "-25px",
              position: "relative",
              fontSize: "20px"
            }}
          >
            Clients
          </div>
        </div>
        <Slider {...settings}>
          {logos.map(({ id, logo }) => (
            <div style={{ padding: '10px' }}>
              <Logo key={id} logo={logo} />
            </div>
          ))}
        </Slider>
      </Col>
    </Row>
  );
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/LogoCarousel/index.js